module.exports = __webpack_public_path__ + "img/logo-new.929890cc.svg";